import styles from "./TheTableSortingHeader.module.css"
const TheTableSortingHeader = ({children}) => {
    return(
        <div className={styles.tableSortingHeaderContainer}>{children}</div>
    );
}

export default TheTableSortingHeader;